import { ActionType } from '../../../borrowers/common/BorrowerConstants';

export interface GeneralContractorActions {
    actionId: ActionType;
    contractorId: number;
    text: string;
    stylingMode: 'contained';
    disabled: boolean;
}

export const getGeneralContractorActions = (contractorId: number) => {
    const actions: GeneralContractorActions[] = [];

    actions.push({
        actionId: ActionType.EditGeneralContractor,
        contractorId,
        text: 'View/Edit',
        stylingMode: 'contained',
        disabled: false,
    });

    actions.push({
        actionId: ActionType.SendPasswordResetEmail,
        contractorId,
        text: 'Password Reset',
        stylingMode: 'contained',
        disabled: false,
    });

    return actions;
};
